(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mobile-navigation"]) return;
  try {
    
function setHeaderHeightVar() {
  const announcement = document.getElementById('x-announcement');
  const header = document.getElementById('x-header-container');

  const announcementHeight = announcement ? announcement.offsetHeight : 0;
  const headerHeight = header ? header.offsetHeight : 0;

  const totalHeight = announcementHeight + headerHeight;

  document.documentElement.style.setProperty('--site-header-height', totalHeight + 'px');
}

window.addEventListener('load', setHeaderHeightVar);
window.addEventListener('resize', setHeaderHeightVar);

  } catch(e) { console.error(e); }
})();
})();
